// extracted by mini-css-extract-plugin
export default {"warn":"OrgsListTableCellPresence_warn__q0Yaj","placeHolderShimmer":"OrgsListTableCellPresence_placeHolderShimmer__8pQDI"};